module.exports = __webpack_public_path__ + "img/Participation.0ba898f1.svg";